/* @flow */
import produce from 'immer';
import { message } from 'antd';
import { actionTypes } from './actions';
import { defineServerErrors } from '@/utils/redux';

const {
  CREATE_QUOTE,
  CREATE_QUOTE_SUCCESS,
  CREATE_QUOTE_FAILED,

  CREATE_PACE_QUOTE,
  CREATE_PACE_QUOTE_SUCCESS,
  CREATE_PACE_QUOTE_FAILED,

  GENERATE_QUOTE,
  GENERATE_QUOTE_SUCCESS,
  GENERATE_QUOTE_FAILED,

  SET_PROPOSAL_ACTIVE,
  SET_PROPOSAL_ACTIVE_SUCCESS,
  SET_PROPOSAL_ACTIVE_FAILED,

  REQUEST_PROPOSAL,
  REQUEST_PROPOSAL_SUCCESS,
  REQUEST_PROPOSAL_FAILED,

  SET_LOADING_PERCENT,
  SHOW_QUOTES_PREVALIDATE_MESSAGES,
  REMOVE_QUOTES_PREVALIDATE_MESSAGE,
  CLEAR_QUOTES_PREVALIDATE_MESSAGES,

  UNLOCK_REQUESTED_PROPOSAL,
  UNLOCK_REQUESTED_PROPOSAL_SUCCESS,
  UNLOCK_REQUESTED_PROPOSAL_FAILED,
} = actionTypes;

type State = {
  isGeneratingQuote: boolean,
  isCreatingQuote: boolean,
  isCreatingPaceQuote: Boolean,
  generateErrors: Array<string>,
  createErrors: Array<string>,
  createPaceQuoteErrors: Array<string>,
  percent: number,
  quotesPrevalidateData: Object,
  unlockRequestedProposalErrors: ?Array<string>,
};

const initialState = {
  isGeneratingQuote: false,
  isCreatingQuote: false,
  isCreatingPaceQuote: false,
  generateErrors: [],
  createErrors: [],
  createPaceQuoteErrors: [],
  percent: 0,
  quotesPrevalidateData: null,
  unlockRequestedProposalErrors: null,
};

export default (state: State = initialState, action: ActionT = {}): State =>
  produce(state, (draft) => {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case CREATE_QUOTE:
        draft.isCreatingQuote = true;
        draft.createErrors = initialState.createErrors;
        return;
      case CREATE_QUOTE_SUCCESS:
        draft.isCreatingQuote = false;
        draft.createErrors = initialState.createErrors;
        message.success(`Quote #${action.payload.id} created successfully.`);
        return;
      case CREATE_QUOTE_FAILED:
        draft.isCreatingQuote = false;
        return;
      case GENERATE_QUOTE:
        draft.isGeneratingQuote = true;
        draft.generateErrors = initialState.generateErrors;
        return;
      case GENERATE_QUOTE_SUCCESS:
        draft.isGeneratingQuote = false;
        draft.generateErrors = initialState.generateErrors;
        message.success(`Quote #${action.payload.id} generated successfully.`);
        return;
      case GENERATE_QUOTE_FAILED:
        draft.isGeneratingQuote = false;
        draft.generateErrors = defineServerErrors(action.payload, 'Some error has occurred. Please try again later.');
        draft.generateErrors.forEach((error) => message.error(error, 10));
        return;
      case SET_PROPOSAL_ACTIVE:
        draft.generateErrors = initialState.generateErrors;
        return;
      case SET_PROPOSAL_ACTIVE_SUCCESS:
        draft.generateErrors = initialState.generateErrors;
        message.success(`Proposal status changed successfully.`);
        return;
      case SET_PROPOSAL_ACTIVE_FAILED:
        draft.generateErrors = defineServerErrors(action.payload, 'Some error has occurred. Please try again later.');
        draft.generateErrors.forEach((error) => message.error(error, 10));
        return;
      case REQUEST_PROPOSAL:
        draft.generateErrors = initialState.generateErrors;
        return;
      case REQUEST_PROPOSAL_SUCCESS:
        draft.generateErrors = initialState.generateErrors;
        message.success(`Proposal requested successfully`);
        return;
      case REQUEST_PROPOSAL_FAILED:
        draft.generateErrors = defineServerErrors(action.payload, 'Some error has occurred. Please try again later.');
        draft.generateErrors.forEach((error) => message.error(error, 10));
        return;
      case CREATE_PACE_QUOTE:
        draft.isCreatingPaceQuote = true;
        draft.createPaceQuoteErrors = initialState.createErrors;
        return;
      case CREATE_PACE_QUOTE_SUCCESS:
        draft.isCreatingPaceQuote = false;
        draft.createPaceQuoteErrors = initialState.createErrors;
        message.success(`Pace Quote #${action.payload.id} created successfully.`);
        return;
      case CREATE_PACE_QUOTE_FAILED:
        draft.isCreatingPaceQuote = false;
        draft.createPaceQuoteErrors = defineServerErrors(
          action.payload,
          'Some error has occurred. Please try again later.',
          'create'
        );
        draft.createPaceQuoteErrors.forEach((error) => message.error(error, 10));
        return;
      case SET_LOADING_PERCENT:
        draft.percent = action.payload;
        return;
      case SHOW_QUOTES_PREVALIDATE_MESSAGES:
        draft.quotesPrevalidateData = action.payload;
        return;
      case REMOVE_QUOTES_PREVALIDATE_MESSAGE: {
        const index = draft.quotesPrevalidateData.messages.findIndex((error) => error.key === action.payload.key);
        if (index !== -1) draft.quotesPrevalidateData.messages.splice(index, 1);
        return;
      }
      case CLEAR_QUOTES_PREVALIDATE_MESSAGES:
        draft.quotesPrevalidateData = initialState.quotesPrevalidateData;
        return;
      case UNLOCK_REQUESTED_PROPOSAL:
        draft.unlockRequestedProposalErrors = initialState.unlockRequestedProposalErrors;
        return;
      case UNLOCK_REQUESTED_PROPOSAL_SUCCESS:
        draft.unlockRequestedProposalErrors = initialState.unlockRequestedProposalErrors;
        message.success(`Proposal requested successfully`);
        return;
      case UNLOCK_REQUESTED_PROPOSAL_FAILED:
        draft.unlockRequestedProposalErrors = defineServerErrors(
          action.payload,
          'Some error has occurred. Please try again later.'
        );
        draft.unlockRequestedProposalErrors.forEach((error) => message.error(error, 10));
        return;
    }
  });
